import { locale as promtComponent } from '@rpc-pwa/components/promt-component/i18n/en';

export const locale = {
    lang: 'en',
    data: {
        ...promtComponent.data
    }
};